var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applePay"},[_c('div',{staticClass:"apple-pay-button custom-styling",attrs:{"id":"applePay"},on:{"click":_vm.processApplePay}})])
}
var staticRenderFns = []

export { render, staticRenderFns }